import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { ImageContentfulModel } from 'src/api/models/Image';
import { ShortParagraphContentModel } from 'src/api/models/ShortParagraph';
import { WealthBuilderSectionContentfulModel } from 'src/api/models/WealthBuilder';
import { WealthBuilderRotatedContainer, WealthBuilderHeading, WealthBuilderAlignedContainer, TextContainer, StartQuotes, EndQuotes, Triangle, SmallSolidTriangle, SolidConfetti, WealthBuilderWrapper } from './wealthBuilder.styles'
import startQuotes from 'src/images/startQuotes.png';
import endQuotes from 'src/images/endQuotes.png';
import TriangleImage from 'src/images/Triangle.png';
import SmallSolidTriangleImage from 'src/images/SmallSolidTriangle.png';
import ConfettiSolidImage from 'src/images/ConfettiSolid.png';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';

export interface WealthBuilderProps {
  data: WealthBuilderSectionContentfulModel
}

const WealthBuilder = ({ data }: WealthBuilderProps): JSX.Element => {
  const heading = data.contentfulchildren.find(child => child.internal.type === 'ContentfulHeading') as HeadingContentfulModel;
  const paragraph = data.contentfulchildren.find(child => child.internal.type === 'ContentfulShortParagraph') as ShortParagraphContentModel;
  const image = data.contentfulchildren.find(child => child.internal.type === 'ContentfulImage') as ImageContentfulModel;

  return (
    <WealthBuilderWrapper>
      <WealthBuilderRotatedContainer />
      <WealthBuilderAlignedContainer>
        <TextContainer>
          <WealthBuilderHeading>
            <StartQuotes src={`${startQuotes}`} alt="Start Quotes" />
            {heading?.text}
            <EndQuotes src={`${endQuotes}`} alt="End Quotes" />
          </WealthBuilderHeading>
          <Paragraph text={paragraph?.text.toUpperCase()} size="1.2rem" weight="light" align="center" color={palette.white} />
        </TextContainer>
        <GatsbyImage image={image.image.gatsbyImageData} alt={image.title}></GatsbyImage>
        <Triangle src={`${TriangleImage}`} alt="Hovering Triangle" />
        <SmallSolidTriangle src={`${SmallSolidTriangleImage}`} alt="Small solid triangle" />
        <SolidConfetti src={`${ConfettiSolidImage}`} alt="Solid Confetti" />
      </WealthBuilderAlignedContainer>
    </WealthBuilderWrapper>
  )
}

export default WealthBuilder;
